export enum UserStatus {
  Available = 0,
  Unavailable = 1,
  Away = 2,
  Dnd = 3,
  Invisible = 4,
  Eager = 5,
  Unknown = 255,
}
